import { Component, AfterViewInit, ComponentFactoryResolver, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { AppService } from '@api';
import { HeaderEnum, RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';
import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { TranslateService } from '@ngx-translate/core';
import { SistemaService } from '@servicios/Sistema.Service';
import { DxDataGridComponent } from 'devextreme-angular';



@Component({
    selector: 'reporteevaluacionpendientedetalle',
    templateUrl: './evaluacionpendientedetalle.component.html',
    styleUrls: ['./evaluacionpendiente.component.scss']
})

export class ReporteEvaluacionPendienteDetalleComponent implements AfterViewInit{
    consulta!:boolean;
    @Input() entidad!: any;
    @Input() accion!: {accionid: number, accion: string};
    @Output() output = new EventEmitter();

    public animacion!: string;
    public abierto!: boolean;

    porcentaje: number = 0;

    listacolaborador:any[];
    listaalumno:any[];
    listaEmail:any[] = [];

    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.listacolaborador = [];
        this.listaalumno = [];
    }

    ngAfterViewInit(){
        this.evaluacionpendiente();
    }

    evaluacionpendiente(){
        this.appService.Post("reporte/evaluacionpendiente/preguntaenviadadetalle",{"entidad":this.entidad, "objeto":this.accion}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                if(this.accion.accionid == 1){
                    this.listacolaborador = res.data;
                }else{
                    this.listaalumno = res.data;
                }
            }
        })
    }

    Salir(){
        this.output.next();
    }

    mandarEmail(limite:number){
      if(limite > 0 && limite <= 99){
        let objeto;
        if(this.accion.accionid == 1){
          const lista = this.listacolaborador.filter(x=>x.conteopregunta != 0 && x.avance <= limite);

          let listaunica: any[] = [];
          lista.forEach(data=>{
           let objeto =  listaunica.findIndex(x=>x.colaboradorid == data.colaboradorid);

           if(objeto >= 0){
            listaunica[objeto]['conteoevaluacion'] = listaunica[objeto]['conteoevaluacion'] + 1;
           }else{
            data["conteoevaluacion"] = 1;
            listaunica.push(data);
           }
          })
          objeto = {"listacolaborador": listaunica};

        }else{
          let listaunica = this.listaalumno.filter(x=>x.avance <= limite);
          if(this.accion.accionid == 3){
           objeto = {"listaalumnos": listaunica};
          }else{
            objeto = {"listapadre": listaunica};
          }
        }
        this.appService.Post("reporte/evaluacionpendiente/enviaremail",objeto, [HeaderEnum.NoShowLoading]).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
          }
        })
      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning, "Asigna un porcentaje valido")
      }
    }

    modal(){
      this.animacion = this.sistemaService.animacionAbirModal;
      this.abierto = true;
    }

    cerrarModal(){
      this.animacion = this.sistemaService.animacionCerrarModal;
      this.porcentaje = 0
      setTimeout(() => {
          this.abierto = false;
      }, 310);
    }

    onRowPrepared(e:any){
        if(e.rowType == "data"){
            e.rowElement.bgColor = e.key.color;
        }

        if(this.accion.accionid == 1){
            if (e.rowType === "group" && e.groupIndex == 0) {
                let grupos:any[] = e.data.items ? e.data.items : e.data.collapsedItems;
                if(grupos){
                    let totalpregunta = 0;
                    let totalpreguntares = 0;
                    let totalpreguntafal = 0;
                    for(let info of grupos){
                        totalpregunta = totalpregunta + info.totalpregunta;
                        totalpreguntares = totalpreguntares + info.totalpreguntares;
                        totalpreguntafal = totalpreguntafal + info.totalpreguntafal;
                    }
                    let avancetotal = 0
                    if(totalpreguntares == 0 && totalpregunta == 0){
                      avancetotal = 0;
                    }else{
                      avancetotal = (totalpreguntares / totalpregunta) * 100;
                    }
                    e.data.avance =  avancetotal.toFixed(0);
                    e.data.cantpregunta = totalpregunta;
                    e.data.cantrespuesta = totalpreguntares;
                }
            }
        }
    }
}
